"use client";

export function PreviewLoading() {
  return (
    <div className="h-64 flex items-center justify-center bg-muted/50">
      <p className="text-sm text-muted-foreground">Loading...</p>
    </div>
  );
}
